import { createContext } from "react";

import type { DetectPlatformResult } from "./detect-platform.js";

export type PlatformContextType = DetectPlatformResult & {
  __ctx_init: boolean;
};

export const PlatformContext = createContext<PlatformContextType>({
  __ctx_init: false,
  hostApplication: "teams",
  platform: "microsoft",
  teamsClientVariant: "desktop",
});
